import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { PropertyDefinition } from "app/library/layout-builder";
import { LayoutScreenDesignerProps } from './types';

export class LayoutScreenDesignerDefinitions extends CmsReactComponent<LayoutScreenDesignerProps> {
    static schemaName = "layout-screen";
    static propertyDefinitions: PropertyDefinition[] = [];
}
